import { A5EventForm } from "./form";

export function A5EventsNew() {
  return <A5EventForm isNew />;
}
